import { render, staticRenderFns } from "./ImageTypeSelector.vue?vue&type=template&id=5db0b857&"
import script from "./ImageTypeSelector.vue?vue&type=script&lang=js&"
export * from "./ImageTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports